<template>
  <div style="margin:20px">
    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Actuals - Booking On-Time Performance Report</span><br/>
      <span style="font-style: italic; font-size: 18px">this report highlights differences between planned booking & actual times.  click any type or status to filter results or any column heading to sort results.</span>
    </div>
    <div style="position: relative; font-weight: bold; font-size: 24px" class="align-right d-flex align-items-center justify-content-center">
      <a href="#" class="arrows" v-on:click.prevent="shift_detail_graph_date(-1)"><</a>
      &nbsp;&nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"></date-picker>&nbsp;&nbsp;
      <a href="#" class="arrows" v-on:click.prevent="shift_detail_graph_date(1)">></a>
      &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
      Early Limit&nbsp;<b-form-select v-model="early_threshold" :options="threshold_options" style="background-color: hsla(120,100%,75%,0.2);font-size: 20px; font-weight: bold; width:90px"/>
      &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
      Late Limit&nbsp;<b-form-select v-model="late_threshold" :options="threshold_options" class="late" style="background-color: rgba(255,0,0,0.2); font-size: 20px; font-weight: bold; width:90px"/>
      &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
      Filter Results&nbsp;<b-form-input style="width: 200px" v-model="booking_filter" placeholder="charterID,vehicle,driver"/>
      &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
      <div class="d-flex align-items-center justify-content-center">
        <b-button size="md" variant="success" @click="download">Download</b-button>
      </div>
    </div>

    <div v-if="!loading">
      <div class="row" style="margin:30px; font-weight: bold; font-size: 24px;">
        <div class="col" style="border: 1px solid grey;">{{items.length}} of {{summary.total_cnt}}</div>
        <div @click="filter_by_type('contract')" class="col contract" :style="selected_type=='contract' ? 'margin-left:15px; border: 2px solid red;' : 'margin-left:15px; border: 1px solid grey;'">Contract: {{summary.contract_cnt}}</div>
        <div @click="filter_by_type('private')" class="col private" :style="selected_type=='private' ? 'border: 2px solid red;' : 'border: 1px solid grey;'">Private: {{summary.private_cnt}}</div>
        <div @click="filter_by_status('ontime')" class="col ontime" :style="selected_status=='ontime' ? 'margin-left:15px; border: 2px solid red;' : 'margin-left:15px; border: 1px solid grey;'">On Time: {{ontime_items.length}}</div>
        <div @click="filter_by_status('early')" class="col early" :style="selected_status=='early' ? 'border: 2px solid red;' : 'border: 1px solid grey;'">Early: {{early_items.length}}</div>
        <div @click="filter_by_status('late')" class="col late" :style="selected_status=='late' ? 'border: 2px solid red;' : 'border: 1px solid grey;'">Late: {{late_items.length}}</div>
      </div>
      <div v-if="summary.companies && summary.companies.length > 1 && summary.companies.length <= 4" class="row" style="margin:0 30px 10px; font-weight: bold; font-size: 20px;">
        <div @click="filter_by_company(null)" class="col company-filter" :style="selected_company==null ? 'border: 2px solid red;' : 'border: 1px solid grey;'">All Companies</div>
        <div v-for="company in summary.companies" :key="company" @click="filter_by_company(company)" class="col company-filter" :style="selected_company==company ? 'border: 2px solid red;' : 'border: 1px solid grey;'">{{company}}</div>
        <div v-if="summary.has_unassigned_company" @click="filter_by_company('__unassigned__')" class="col company-filter" :style="selected_company=='__unassigned__' ? 'border: 2px solid red;' : 'border: 1px solid grey;'">Unassigned</div>
      </div>
      <div v-if="summary.companies && summary.companies.length > 4" style="margin:0 30px 10px; display: flex; align-items: center; justify-content: center;">
        <span style="font-weight: bold; font-size: 20px; margin-right: 10px;">Company:</span>
        <b-form-select v-model="selected_company" :options="company_options" @change="filter_items()" style="font-size: 18px; font-weight: bold; max-width: 400px;"/>
      </div>
    </div>

    <table v-if="!loading" width="100%" border="1" cellpadding="2">
      <tr>
        <th colspan="5" style="font-size: 18px; font-weight: bold;">&nbsp;</th>
        <th style="background-color: lightgrey" colspan="3" v-for="time_field in summary.time_fields" @click="sort_dates('planned' + time_field + 'DateTime')">{{time_field}}</th>
      </tr>
      <tr>
        <th width="60px" @click="sort_numbers('charterID')">CharterID</th>
        <th width="60px" @click="sort_numbers('movementID')">MvmtID</th>
        <th width="60px" @click="sort_strings('clientID')">ClientID</th>
        <th width="60px" @click="sort_strings('vehicle')">Vehicle</th>
        <th width="60px" @click="sort_strings('driver')">Driver</th>
        <template v-for="time_field in summary.time_fields">
          <th width="60px" @click="sort_dates('planned' + time_field + 'DateTime')">Planned</th>
          <th width="60px" @click="sort_dates('actual' + time_field + 'DateTime')">Actual</th>
          <th width="30px" @click="sort_numbers(time_field + 'Delta')">Diff</th>
        </template>
      </tr>
      <template v-for="item in items">
        <tr>
          <td align="center">{{ item.charterID }}</td>
          <td align="center">
            <router-link style="font-weight: bold;" :to="{ path: '/actuals?booking_id=' + item.booking_hash }">{{ item.movementID }}</router-link>
          </td>
          <td align="center">{{ item.clientID }}</td>
          <td align="center">{{ item.vehicle }}</td>
          <td align="center">{{ item.driver }}</td>
          <template v-for="time in item.times">

            <td v-if="time.field=='Start' || time.field == 'Finish'">{{time.planned | formatDateTimeSmall}}</td>
            <td v-else>{{time.planned | formatTimeSmall}}</td>
            <td v-if="time.field=='Start' || time.field == 'Finish'">{{time.actual | formatDateTimeSmall}}</td>
            <td v-else>{{time.actual | formatTimeSmall}}</td>
            <td v-if="time.actual && time.delta < 0 && Math.abs(time.delta) > early_threshold" class="early">{{time.delta | units('m')}}</td>
            <td v-else-if="time.actual && time.delta > 0 && time.delta > late_threshold" class="late">{{time.delta | units('m')}}</td>
            <td v-else-if="time.delta">{{time.delta | units('m')}}</td>
            <td v-else>&nbsp;</td>
          </template>
        </tr>
      </template>
    </table>
    <div v-else>
      <br/><br/>
      <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
    </div>
  </div>

</template>
<script>
import {api_url, get_actuals_performance_report} from '../networking/apis'
import {mapState} from "vuex"
import {justDate} from '../helpers/dates'
import moment from 'moment'
import axios from "axios";

export default {
  name: 'actuals_perf_report',

  components: {
  },

  data() {
    return {
      booking_filter: '',
      items: [],
      ontime_items: [],
      early_items: [],
      late_items: [],
      summary: [],
      early_threshold: 10,
      late_threshold: 10,
      selected_type: null,
      selected_status: null,
      selected_company: null,
      threshold_options: [
        { value: '1', text: '1m' },
        { value: '5', text: '5m' },
        { value: '10', text: '10m' },
        { value: '15', text: '15m' },
        { value: '20', text: '20m' },
        { value: '30', text: '30m' },
        { value: '45', text: '45m' },
        { value: '60', text: '1h' },
        { value: '120', text: '2h' },
        { value: '240', text: '4h' },
      ],
      loading: false,
      details_fromDate: justDate(moment().subtract(1, 'days')),

      options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        minDate: moment().subtract(90, 'days'),
        maxDate: moment().add(90, 'days'),
        keepOpen: false,
        showClear: true,
        showClose: true,
      },
    }
  },
  created() {
    this.load_data()
  },
  methods: {
    async load_data() {
      this.loading = true
      try {
        const {value: {data = []}} = await get_actuals_performance_report(this.user.tenant, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'))
        this.summary = data.summary
        moment.tz.setDefault(this.summary.timezone)
        this.items = data.results
        this.items_full = data.results
        this.calc_otp_status()
        this.filter_items()
      } catch(e){
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }
      this.loading = false
    },
    async calc_otp_status() {
      if (this.items && this.items.length > 0) {
        for (const item of this.items) {
          let otp_status = ''
          for (const time of item.times) {
            if (time.actual && time.delta < 0 && Math.abs(time.delta) > this.early_threshold) {
              otp_status += '+early'
            } else if (time.actual && time.delta > 0 && time.delta > this.late_threshold) {
              otp_status += '+late'
            }
          }
          if (otp_status == '')
              otp_status = 'ontime'
          item.otp_status = otp_status
        }
      }
      this.ontime_items = this.items_full.filter(item => item.otp_status.indexOf('ontime') != -1)
      this.early_items = this.items_full.filter(item => item.otp_status.indexOf('early') != -1)
      this.late_items = this.items_full.filter(item => item.otp_status.indexOf('late') != -1)
    },
    async shift_detail_graph_date(shift) {
      this.details_fromDate = moment(this.details_fromDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
    },
    filter_items() {
      this.items = this.items_full
      if (this.selected_company === '__unassigned__')
        this.items = this.items.filter(item => !item.companyID)
      else if (this.selected_company)
        this.items = this.items.filter(item => item.companyID == this.selected_company)
      if (this.selected_type)
        this.items = this.items.filter(item => item.booking_type == this.selected_type)
      if (this.selected_status)
        this.items = this.items.filter(item => item.otp_status.indexOf(this.selected_status) != -1)
      if (this.booking_filter)
        this.items = this.items.filter(item => (item.charterID.indexOf(this.booking_filter) != -1 || (item.driver != null && item.driver.indexOf(this.booking_filter) != -1) || (item.vehicle != null && item.vehicle.indexOf(this.booking_filter) != -1)))
    },
    filter_by_company(company) {
      this.selected_company = (company == null || this.selected_company == company) ? null : company
      this.filter_items()
    },
    filter_by_type(type) {
      if (type == null || this.selected_type == type) {
        this.selected_type = null
      } else {
        this.selected_type = type
      }
      this.filter_items()
    },
    filter_by_status(status) {
      if (status == null || this.selected_status == status) {
        this.selected_status = null
      } else {
        this.selected_status = status
      }
      this.filter_items()
    },
    sort_dates(col) {
      console.log("sort_dates:" + col)
      if (this.sort_col == col) {
        this.items = this.items.reverse()
      } else {
        this.items = this.items.sort((a, b) => {
          // console.log("sort:" + a[col] + ", " + b[col])

          if (a[col] && !b[col]) {
            return -1
          } else if (!a[col] && b[col]) {
            return 1
          } else if (!a[col] && !b[col]) {
            return -1
          } else {
            return new Date(a[col]) - new Date(b[col])
          }
        })
      }
      this.sort_col = col
    },
    sort_numbers(col) {
      if (this.sort_col == col) {
        this.items = this.items.reverse()
      } else {
        this.items = this.items.sort((a, b) => {
          if (a[col] && !b[col]) {
            return -1
          } else if (!a[col] && b[col]) {
            return 1
          } else if (!a[col] && !b[col]) {
            return -1
          } else {
            return a[col] - b[col]
          }
        })
      }
      this.sort_col = col
    },
    sort_strings(col) {
      if (this.sort_col == col) {
        this.items = this.items.reverse()
      } else {
        this.items = this.items.sort((a, b) => {
          if (a[col] && !b[col]) {
            return -1
          } else if (!a[col] && b[col]) {
            return 1
          } else if (!a[col] && !b[col]) {
            return -1
          } else {
            let fa = a[col].charAt(0).toLowerCase(),
                fb = b[col].charAt(0).toLowerCase();

            if (fa < fb) {
              return -1;
            }
            if (fa > fb) {
              return 1;
            }
            return 0;
          }
        })
      }
      this.sort_col = col
    },
    async download(){
      this.$emit('showAlert', 'processing download request', 'info', 5000)
      axios.defaults.headers.common.Accept = {}
      axios.post(
          `${api_url}bookings/reports/actuals/performance/download`,
          {
            tenant: this.user.tenant,
            date: moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
          }, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('jwt')}`,
              Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            },
            responseType: 'blob'
          }
      ).then((response) => {
        axios.defaults.headers.common.Accept = 'application/json'
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute(
            'download',
            `actuals-perf-${this.user.tenant}-${this.details_fromDate}.csv`
        )
        document.body.appendChild(link)
        link.click()
        this.$emit('showAlert', 'download complete', 'success', 5000)
      }).catch(e => {
        axios.defaults.headers.common.Accept = 'application/json'
        this.$emit('showAlert', 'data could not be downloaded.', 'danger')
      })
    },
  },
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
    company_options() {
      const opts = [{value: null, text: 'All Companies'}]
      for (const c of this.summary.companies || []) opts.push({value: c, text: c})
      if (this.summary.has_unassigned_company) opts.push({value: '__unassigned__', text: 'Unassigned'})
      return opts
    },
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.load_data()
      }
    },
    details_fromDate(target_from_date) {
      this.selected_type = null
      this.selected_company = null
      this.details_fromDate = target_from_date
      this.load_data();
    },
    early_threshold(val) {
      this.calc_otp_status()
    },
    late_threshold(val) {
      this.calc_otp_status()
    },
    booking_filter() {
      this.filter_items()
    },
  }
}
</script>

<style>
.arrows {font-size: 22px; font-weight: bold; color: var(--fi-rail-accent) !important }

.early-duration { background-color: hsla(120,100%,75%,0.2)}
.late-duration { background-color: rgba(255,0,0,0.2)}

.early { background-color: hsla(120,100%,75%,0.2)}
.late { background-color: rgba(255,0,0,0.2)}
.ontime { background-color: hsla(200,75%,50%,0.2)}
.private { background-color: hsla(200,40%,80%,0.2) }
.contract { background-color: hsla(250,60%,70%,0.2) }
.company-filter { background-color: hsla(35,80%,70%,0.2) }

</style>
